import React, { ReactElement } from 'react';
import './ProgressStepper.scss';
import { StepComponent, RawStep } from './Step';

interface ProgressStepperProps {
  steps: RawStep[];
}

export function ProgressStepper({ steps }: ProgressStepperProps): ReactElement {
  return (
    <div className="progress-stepper__container">
      {steps.map((stepProps: RawStep, index: number) => (
        <StepComponent key={'step-' + index} isLast={index === steps.length - 1} index={index + 1} {...stepProps} />
      ))}
    </div>
  );
}

export type Step = RawStep;
